import { createFileRoute } from "@tanstack/react-router";

import { LoadingIcon } from "@web-app/components";
import { useApp } from "@web-app/hooks";
import ChatEventsProvider from "@web-app/pages/chatPage/ChatEventsProvider";
import OptimizationWizard from "@web-app/pages/costOptimizer/OptimizationWizard";

export const Route = createFileRoute("/cpd/new")({
  component: NewOptimization,
});

function NewOptimization() {
  const { sessionUser, isLoading, logout } = useApp();

  if (isLoading || !sessionUser) {
    return (
      <div className="h-screen w-screen grid place-content-center">
        <LoadingIcon className="w-8 h-8" />
      </div>
    );
  }

  const draftId =
    new URLSearchParams(window.location.search).get("draftId") || undefined;

  return (
    <ChatEventsProvider>
      <OptimizationWizard draftId={draftId} logout={logout} />
    </ChatEventsProvider>
  );
}
